import { Navigate, useLocation } from 'react-router-dom';

interface Props {
  ownerModule: string;
}

/** Redirects legacy module approval inboxes to the global approval engine inbox. */
export function ModuleApprovalsRedirect({ ownerModule }: Props) {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  if (!params.has('ownerModule')) {
    params.set('ownerModule', ownerModule);
  }
  if (params.get('mine') === '1') {
    params.set('mineOnly', 'true');
  }
  const qs = params.toString();
  return <Navigate to={`/work/approvals${qs ? `?${qs}` : ''}`} replace />;
}
